/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutStatus } from './CarveOutStatus';
import {
    CarveOutStatusFromJSON,
    CarveOutStatusFromJSONTyped,
    CarveOutStatusToJSON,
    CarveOutStatusToJSONTyped,
} from './CarveOutStatus';

/**
 * 
 * @export
 * @interface CarveOutMedicationSummary
 */
export interface CarveOutMedicationSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    medication_name: string;
    /**
     * 
     */
    status: CarveOutStatus;
    /**
     * 
     */
    is_complete: boolean;
    /**
     * 
     */
    cost_per_day?: number;
}



/**
 * Check if a given object implements the CarveOutMedicationSummary interface.
 */
export function instanceOfCarveOutMedicationSummary(value: object): value is CarveOutMedicationSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('medication_name' in value) || value['medication_name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('is_complete' in value) || value['is_complete'] === undefined) return false;
    return true;
}

export function CarveOutMedicationSummaryFromJSON(json: any): CarveOutMedicationSummary {
    return CarveOutMedicationSummaryFromJSONTyped(json, false);
}

export function CarveOutMedicationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutMedicationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'medication_name': json['medication_name'],
        'status': CarveOutStatusFromJSON(json['status']),
        'is_complete': json['is_complete'],
        'cost_per_day': json['cost_per_day'] == null ? undefined : json['cost_per_day'],
    };
}

export function CarveOutMedicationSummaryToJSON(json: any): CarveOutMedicationSummary {
    return CarveOutMedicationSummaryToJSONTyped(json, false);
}

export function CarveOutMedicationSummaryToJSONTyped(value?: CarveOutMedicationSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'medication_name': value['medication_name'],
        'status': CarveOutStatusToJSON(value['status']),
        'is_complete': value['is_complete'],
        'cost_per_day': value['cost_per_day'],
    };
}

